import { render, staticRenderFns } from "./PersonalDescription.vue?vue&type=template&id=37daf6e9"
import script from "./PersonalDescription.vue?vue&type=script&lang=js"
export * from "./PersonalDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports